import React, { useEffect } from 'react';
import { loadRecaptchaEnterprise } from './recaptchaEnterprise';

/**
 * Précharge enterprise.js (pas de widget visible — clé score).
 * Le jeton est obtenu au submit via executeRecaptchaEnterprise().
 */
function RecaptchaWidget({ siteKey }) {
  useEffect(() => {
    if (!siteKey) return undefined;
    loadRecaptchaEnterprise(siteKey).catch(() => {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('[reCAPTCHA Enterprise] chargement échoué');
      }
    });
    return undefined;
  }, [siteKey]);

  return (
    <p className="text-xs text-gray-500">
      Ce site est protégé par reCAPTCHA Enterprise. Les{' '}
      <a
        className="underline"
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
      >
        règles de confidentialité
      </a>{' '}
      et{' '}
      <a
        className="underline"
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
      >
        conditions d’utilisation
      </a>{' '}
      de Google s’appliquent.
    </p>
  );
}

export default RecaptchaWidget;
